"use-strict";

import Waypoint from '../assets/plugins/waypoint/noframework.waypoints.min';
import 'jquery';
export class Scroll {
    logo = null;
    lastScrollTop = 0;
    scrolling = false;
    header = $('#section-header');
    headerLarge = $('#header-fixed-large');

    constructor () {
        this.init();
    }

    addMinified() {
        this.scrolling = true;
        this.header.addClass('header--minified');
    }

    removeMinified() {
        this.scrolling = true;
        this.header.removeClass('header--minified');
    }

    stopScrolling() {
        setTimeout(() => {
            this.scrolling = false;
        }, 20);
    }

    toggleMinified() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > this.lastScrollTop && !this.scrolling) {
            this.addMinified();
        } else if (!this.scrolling && scrollTop <= 0) {
            this.removeMinified();
        }
        this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

        this.stopScrolling();

    }

    handleLargeScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const menuHeight = document.getElementById('section-header').offsetHeight;
        if (scrollTop >= menuHeight && !this.scrolling) {
            this.scrolling = true;
            this.headerLarge.addClass('header-fixed-show');
        } else if (!this.scrolling && scrollTop <= menuHeight) {
            this.headerLarge.removeClass('header-fixed-show');
        }

        this.stopScrolling();
    }

    handleScroll() {
        const screenWidth = window.screen.width;
        if (screenWidth < 768) {
            this.toggleMinified();
        }
        if (screenWidth >= 768) {
            this.handleLargeScroll();
        }

    }

    startScroll() {
        window.addEventListener('scroll', () => this.handleScroll());
    }

    init() {
        this.handleScroll();
        this.logo = document.getElementById('logo-header');
        if (this.logo) {
            this.startScroll();
        }
    }
}
